<div class="bg-dark">
    <div class="col p-0" *ngIf="initData">
        <pt-touch-swiper [swiperData]="initData.viewModel.slides"></pt-touch-swiper>
    </div>
</div>
